import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import arabic from './locales/ar.json';
import english from './locales/en.json';
import hebrew from './locales/he.json';
import spanish from './locales/es.json';

export const SUPPORTED_LOCALES = ['en', 'ar', 'he', 'es'] as const;

void i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: english },
            ar: { translation: arabic },
            he: { translation: hebrew },
            es: { translation: spanish }
        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export { i18n };
